<template>
    <el-form status-icon :model="kwForm" :rules="rulesKW" ref="kwForm" @submit.native.prevent="enter"
             class="demo-ruleForm">
        <div>
            <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item label='KW Adı'
                                  prop="kwAdi" class="margin-top-20">:
                        <el-input
                                v-model="kwForm.kwAdi"
                                placeholder='KW Adı Giriniz'></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
        <el-row class="col-p">
            <el-form-item>
                <el-button size="small" v-on:click="kwTanimla('kwForm')"
                           type="primary">
                    Tanımla
                </el-button>
            </el-form-item>
        </el-row>
    </el-form>

</template>

<script>
    import EventBus from '@/components/event-bus'

    import kwService from '../../../../WSProvider/OpsiyonService'
    import notification from '../../../../notification'
    export default {
        name: "KWEkle",
        mounted() {
            this.getKWListesi();
        },
        data() {
            return {
                kwListesi: [],
                kwForm: {
                    kwAdi: '',
                },
                rulesKW: {
                    kwAdi: [{
                        required: true,
                        message: "Lütfen Kw Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            getKWListesi() {
                kwService.kwList(1, "", "").then((response) => {
                    if (response.status === 200) {
                        this.kwListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            kwTanimla(formName) {
                var dizi = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        kwService.kwTanimlama(this.kwForm.kwAdi).then((response) => {
                            if (response.status === 200) {
                                this.kwListesi.push(response.data);
                                this.kwListesi.forEach(function (value) {
                                    dizi.push({
                                        secenekAdi: value.kwAdi,
                                        secenekKodu: value.kwKodu,
                                    })
                                });
                                EventBus.$emit("opsiyonList", true)
                                // this.$store.commit('changeOpsiyonList', dizi);
                                notification.Status('success', this, 'KW başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kw zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>